import React from "react";
import { Wave } from "./Wave";
type SectionProps = {
  id?: string;
  labelledBy: string;
  className?: string;
  waveTo?: string;
  bleed?: boolean;
  children: React.ReactNode;
};
export function Section({
  id,
  labelledBy,
  className = "",
  waveTo,
  bleed = false,
  children
}: SectionProps) {
  return <section id={id} aria-labelledby={labelledBy} className={`relative pt-14 ${waveTo ? "pb-20 sm:pb-24" : "pb-14"} ${bleed ? "" : "px-5 sm:px-10"} ${className}`} data-id="element-194" data-mp="3kuouf1w6rkfv">
      {children}
      {waveTo && <Wave fill={waveTo} data-id="element-195" data-mp="hf15y4c1dxhf" />}
    </section>;
}